/*
 * Engravity: picture pickers on product pages.
 *  1. Name badge "Shape" variant dropdown -> grid of the 14 badge shapes (just the outline), drawn in the selected badge color, with the price of each.
 *  2. Font code dropdown (S1-S18 script, P1-P18 print, rendered by the image uploader app) -> grid of live font previews.
 * Both pickers drive the original dropdowns, so the cart receives exactly the same data as before.
 * Shape outlines come from the shop's own cut files (mm). Fonts are the Google Fonts behind each code.
 */
(function () {
  'use strict';

  var SHAPES = {"1":[76.2,25.4,"M13.35,0L62.82,0C70.19,0 76.2,2.99 76.2,6.68L76.2,18.72C76.2,22.41 70.22,25.4 62.82,25.4L13.35,25.4C5.98,25.4 0,22.41 0,18.72L0,6.68C-0.03,2.99 5.96,0 13.35,0Z"],"2":[76.2,25.4,"M0.26,10.7C0.55,9.69 1.56,8.02 2.57,6.89C3.63,5.69 5.13,4.61 9.25,2.08L12.62,0L38.19,0L63.75,0L67.29,2.15C69.23,3.34 71.22,4.6 71.7,4.96C73.15,6.05 74.57,7.59 75.4,8.98C76.11,10.16 76.18,10.52 76.2,12.63C76.22,15.26 75.75,16.5 73.95,18.48C72.7,19.87 71.82,20.51 67.53,23.17L63.95,25.4L38.18,25.4L12.42,25.39L8.76,23.14C6.76,21.91 4.54,20.42 3.84,19.85C0.77,17.3 -0.62,13.76 0.26,10.7Z"],"3":[80.19,38.1,"M38.23,36.4C37.29,35.47 36.2,34.56 35.8,34.39C35.13,34.11 34.03,34.08 22.05,34C9.43,33.92 9,33.9 8.28,33.56C7.87,33.37 7.26,32.87 6.94,32.46C6.36,31.73 6.34,31.54 6.34,27.19C6.34,22.7 6.34,22.66 5.69,21.95C5.03,21.22 3.09,20.17 1.12,19.47L0,19.08L1.38,18.57C3.15,17.92 4.88,17.01 5.62,16.33C6.19,15.82 6.21,15.61 6.34,10.93C6.49,5.36 6.55,5.19 8.72,4.48C9.89,4.1 9.96,4.1 22.34,4.1C34.27,4.1 34.81,4.09 35.64,3.76C36.49,3.43 36.84,3.14 38.91,1.07C39.5,0.48 40.08,0 40.21,0C40.33,0 41.01,0.58 41.71,1.3C42.41,2.01 43.26,2.82 43.61,3.1C44.88,4.12 44.59,4.1 58.14,4.1L70.54,4.1L71.71,4.49C72.54,4.77 73.05,5.1 73.47,5.64C74.04,6.37 74.07,6.56 74.07,10.89C74.07,15.01 74.11,15.45 74.58,16.04C75.19,16.82 76.35,17.5 78.55,18.38L80.19,19.03L78.96,19.23C77.14,19.53 75.66,20.28 74.8,21.34L74.07,22.25L74.06,26.97C74.05,32.27 73.93,32.7 72.18,33.5L71.29,33.91L58.31,34C46.37,34.08 45.28,34.11 44.61,34.39C44.21,34.56 43.11,35.47 42.18,36.4C41.24,37.34 40.35,38.1 40.2,38.1C40.05,38.1 39.16,37.34 38.23,36.4Z"],"4":[76.2,38.1,"M37.16,36.57C35.33,33.27 32.94,31.05 31.2,31.04C30.71,31.04 26.64,31.67 22.16,32.45C17.67,33.22 13.44,33.85 12.75,33.85C9.24,33.85 6.68,31.07 6.3,26.85C6.22,25.91 6.01,24.83 5.83,24.44C5.11,22.88 2.94,20.78 0.9,19.67C0.41,19.4 0,19.1 0,19.01C0,18.92 0.36,18.64 0.81,18.38C1.99,17.7 3.61,16.42 4.46,15.48C5.8,13.99 6.12,13.24 6.31,11.2C6.6,8.01 7.82,5.91 10.07,4.74C11.83,3.83 12.56,3.88 22.29,5.55C27.66,6.47 31.37,7.01 31.71,6.93C33.39,6.52 35.43,4.49 37.04,1.64C37.55,0.73 38.02,-0 38.08,0C38.14,0 38.56,0.68 39.02,1.51C40,3.28 41.47,5.13 42.56,5.98C44.18,7.23 44.02,7.24 53.86,5.55C60.4,4.43 63.08,4.05 63.95,4.12C67.11,4.39 69.53,7.27 69.8,11.08C69.87,12.05 70.06,12.99 70.32,13.55C70.9,14.84 72.65,16.64 74.55,17.89L76.2,18.99L74.68,19.98C72.84,21.18 70.83,23.25 70.31,24.47C70.1,24.96 69.88,26.02 69.81,26.82C69.67,28.59 69.34,29.68 68.57,30.93C67.46,32.75 65.57,33.83 63.44,33.85C62.75,33.86 58.5,33.23 53.99,32.46C49.48,31.68 45.41,31.04 44.95,31.04C43.17,31.04 41.08,32.92 39.15,36.24C38.56,37.27 38.05,38.1 38.04,38.1C38.02,38.1 37.62,37.41 37.16,36.57Z"],"5":[76.2,25.4,"M4.18,0L72.02,0C74.31,0 76.2,0.93 76.2,2.09L76.2,23.31C76.2,24.46 74.34,25.4 72.02,25.4L4.18,25.4C1.89,25.4 0,24.47 0,23.31L0,2.09C0,0.94 1.89,0 4.18,0Z"],"6":[76.2,38.12,"M32.94,37.84C27.24,37.18 20.41,34.76 16.68,32.08L14.96,30.85L8.47,30.85C2.11,30.85 1.95,30.83 0.99,30L0,29.15L0,19.06L0,8.96L0.99,8.11C1.95,7.28 2.11,7.26 8.47,7.26L14.96,7.26L16.63,6.07C27.77,-1.86 47.04,-2.05 58.95,5.66L61.44,7.26L67.96,7.26C74.41,7.26 74.48,7.27 75.34,8.13L76.2,8.99L76.2,19C76.2,28.33 76.15,29.07 75.53,29.84C74.87,30.65 74.69,30.67 67.87,30.85L60.89,31.02L58.76,32.5C52.61,36.77 42.21,38.92 32.94,37.84Z"],"7":[62.13,29.77,"M13.06,29.71C9.66,29.19 6.73,27.71 4.31,25.28C1.2,22.16 -0.19,18.54 0.02,14.15C0.34,7.62 4.44,2.41 10.77,0.5C12.42,0 13.13,-0.06 15.53,0.04C19.57,0.23 22.5,1.46 25.36,4.18L26.5,5.27L44.32,5.27L62.13,5.27L62.13,14.8L62.13,24.32L44.38,24.32L26.62,24.32L25.16,25.66C23.35,27.32 21.5,28.4 19.35,29.07C17.67,29.6 14.48,29.92 13.06,29.71Z"],"8":[50.8,50.8,"M22.95,49.36C20.02,47.33 15.43,43.2 13.1,40.49C5.06,31.15 0.76,20.11 0.17,7.26L0,3.55L0.76,3.69C4.52,4.39 6.71,4.56 10.28,4.45C15.99,4.27 19.85,3.27 23.83,0.94L25.43,0L26.68,0.77C32.9,4.63 41.53,5.72 50.08,3.74L50.8,3.57L50.8,6.36C50.8,9.72 50.27,13.87 49.36,17.58C46.71,28.44 40.89,37.85 32.12,45.51C29.29,47.98 25.59,50.8 25.19,50.8C25.1,50.8 24.09,50.15 22.95,49.36Z"],"9":[76.2,50.8,"M34.27,50.52C30.32,49.79 27.12,48.29 23.76,45.6L22.43,44.54L16.64,44.54L10.86,44.54L10.86,42.07L10.86,39.6L8.56,39.6L6.27,39.6L6.27,37.4L6.27,35.2L4.01,33.11C2.73,31.93 1.37,30.34 0.88,29.43C0.11,28.03 0,27.51 0,25.36C0,23.25 0.12,22.67 0.8,21.43C1.78,19.68 3.68,17.58 5.17,16.62L6.26,15.91L6.26,13.51L6.27,11.12L8.56,11.12L10.86,11.12L10.86,8.65L10.86,6.18L16.7,6.18L22.54,6.18L24.12,4.86C26.16,3.17 30.41,1.08 33.09,0.47C35.85,-0.16 40.69,-0.16 43.3,0.49C46.05,1.17 49.28,2.73 51.56,4.48C52.62,5.29 53.71,5.99 53.98,6.04C54.25,6.09 56.91,6.14 59.9,6.15L65.33,6.18L65.33,8.65L65.33,11.12L67.63,11.12L69.93,11.12L69.93,13.31L69.93,15.5L72.32,17.74C75.5,20.71 76.2,22.08 76.2,25.36C76.2,28.63 75.5,30.01 72.32,32.97L69.93,35.21L69.93,37.41L69.93,39.6L67.63,39.6L65.33,39.6L65.33,42.07L65.33,44.54L59.81,44.54C53.81,44.54 53.79,44.55 51.56,46.3C49.71,47.77 46.65,49.3 44.12,50.03C41.4,50.82 37.04,51.04 34.27,50.52Z"],"10":[76.2,46.63,"M9.25,46C4.27,44.4 1.15,40.33 0.15,34.09C-0.42,30.53 0.63,26.31 2.84,23.32C4.85,20.59 9.6,18.32 13.32,18.32L14.99,18.32L15.84,16.46C18,11.74 22.82,8.98 28.91,8.98C31.21,8.98 31.21,8.98 32.19,7.57C34.49,4.25 38.38,1.56 42.43,0.48C44.86,-0.17 49.67,-0.16 52.26,0.5C55.68,1.36 59.82,3.61 62.32,5.94C65.89,9.28 67.34,12.35 67.36,16.62C67.37,18.87 67.38,18.9 68.62,19.56C70.76,20.7 73.47,23.65 74.59,26.04C76.08,29.21 76.49,31.97 76.01,35.43C75.29,40.56 73.13,43.72 69.05,45.64L67.14,46.54L39.27,46.61C12.36,46.68 11.33,46.66 9.25,46Z"],"11":[76.2,46.81,"M45,45.46C46.37,43.97 47.21,42.29 47.51,40.43L47.71,39.22L40.65,39.37C30.46,39.58 23.91,38.73 16.89,36.29C8.98,33.54 3.6,29.67 0.96,24.82C0.04,23.13 0,22.91 0,19.8C0,16.69 0.04,16.48 1,14.64C1.64,13.39 2.79,11.94 4.25,10.5C18.78,-3.75 58.58,-3.43 72.24,11.06C76.38,15.45 77.29,20.17 74.9,24.96C73.75,27.27 69.96,30.96 66.9,32.75C64.11,34.38 59.75,36.24 56.94,36.99C55.13,37.47 54.99,37.57 54.18,39C53.01,41.08 49.69,44.06 46.86,45.56C45.56,46.25 44.33,46.81 44.13,46.81C43.92,46.81 44.32,46.2 45,45.46Z"],"12":[76.2,43.89,"M0,31.26L0,18.62L2.46,17.38L4.92,16.14L4.92,11.06L4.92,5.97L9.3,5.97L13.69,5.97L13.69,8.8C13.69,11.58 13.71,11.63 14.48,11.39C14.92,11.25 20.29,8.63 26.42,5.57C32.55,2.51 37.79,0 38.05,0C38.32,0 47.01,4.18 57.37,9.29L76.2,18.57L76.2,31.23L76.2,43.89L38.1,43.89L0,43.89L0,31.26Z"],"13":[76.2,55.03,"M76.2,27.52C76.2,42.71 59.14,55.03 38.1,55.03C17.06,55.03 0,42.71 0,27.52C0,12.32 17.06,0 38.1,0C59.14,0 76.2,12.32 76.2,27.52Z"],"14":[95.25,56.15,"M93.06,24.96L52.91,1.28C49.99,-0.43 45.26,-0.43 42.34,1.28L2.19,24.96C-0.73,26.68 -0.73,29.48 2.19,31.19L42.34,54.87C45.26,56.58 49.99,56.58 52.91,54.87L93.06,31.19C95.98,29.48 95.98,26.68 93.06,24.96Z"]};

  // Plate finishes (same palette the shop's proof mockups use).
  var PLATES = {
    'gold':        { stops: ['#b8913a', '#e9d08a', '#f6e7b0', '#d9b865', '#b08a36'], edge: '#9a7629' },
    'silver':      { stops: ['#8f959b', '#d5d9dc', '#f2f4f5', '#bfc4c8', '#8c9298'], edge: '#737a80' },
    'black':       { stops: ['#111111', '#2b2b2b', '#151515'], edge: '#000000' },
    'white':       { stops: ['#ffffff', '#f1f1f1'], edge: '#b5b5b5' },
    'blue marble': { stops: ['#1b3f86', '#3a63b5', '#24498f', '#5f84c9', '#1b3f86'], edge: '#153670', marble: true },
    'blue':        { stops: ['#1b4691', '#2e62bd', '#1b4691'], edge: '#153670' },
    'walnut':      { stops: ['#6e4a2e', '#8a6143', '#6a462b'], edge: '#4a301c', grain: true },
    'rose gold':   { stops: ['#b0776a', '#e5b3a3', '#f5d6ca', '#d49a8a', '#a86c5f'], edge: '#8f5a4d' },
    'copper':      { stops: ['#9a5a2c', '#d68b55', '#efb187', '#c47a45', '#8f5028'], edge: '#7a4420' },
    'brass':       { stops: ['#a8893b', '#d9c170', '#eedd9c', '#cdb05e', '#9c7e33'], edge: '#86692a' },
    'bronze':      { stops: ['#7d5a2e', '#b58a52', '#d1ab76', '#a67c46', '#735228'], edge: '#5f4420' },
    'red':         { stops: ['#a51c25', '#c9313b', '#a51c25'], edge: '#7d141b' },
    'navy':        { stops: ['#172440', '#253861', '#172440'], edge: '#0f1a30' },
    'green':       { stops: ['#1a6b32', '#2a8f47', '#1a6b32'], edge: '#135227' },
    'teal':        { stops: ['#177373', '#239191', '#177373'], edge: '#105656' },
    'gray':        { stops: ['#7d8287', '#9aa0a5', '#7d8287'], edge: '#5d6166' },
    'grey':        { stops: ['#7d8287', '#9aa0a5', '#7d8287'], edge: '#5d6166' },
    'wood':        { stops: ['#c89b6b', '#ddb68a', '#c2915f'], edge: '#8e6641', grain: true },
    'maple':       { stops: ['#e4c9a0', '#f0dcbc', '#dfc193'], edge: '#a88b62', grain: true },
    'cherry':      { stops: ['#9c5a3c', '#b77254', '#955336'], edge: '#6d3d27', grain: true }
  };
  var INKS = { black: '#111111', white: '#ffffff', gold: '#d4b25a', silver: '#d9dde0', 'rose gold': '#d19c8c', copper: '#c47a45', red: '#b3202a', blue: '#1f4fa3', navy: '#1b2a4a', green: '#1f7a3a', brown: '#3b2414', gray: '#7d8287', grey: '#7d8287' };

  var FONTS = {"S1":"Great Vibes","S2":"Pacifico","S3":"Lobster","S4":"Dancing Script","S5":"Allura","S6":"Sacramento","S7":"Kaushan Script","S8":"Yellowtail","S9":"Cookie","S10":"Rochester","S11":"Alex Brush","S12":"Marck Script","S13":"Parisienne","S14":"Petit Formal Script","S15":"Italianno","S16":"Bad Script","S17":"Tangerine","S18":"Satisfy","P1":"Montserrat","P2":"Oswald","P3":"Lato","P4":"Raleway","P5":"Bebas Neue","P6":"Roboto","P7":"Poppins","P8":"Anton","P9":"Josefin Sans","P10":"Playfair Display","P11":"Merriweather","P12":"Lora","P13":"Cormorant Garamond","P14":"Libre Baskerville","P15":"Arvo","P16":"Bitter","P17":"Cinzel","P18":"Julius Sans One"};
  var FONT_SAMPLE = 'Jenny Wilson';
  // Scripts render small; give them a touch more size.
  var FONT_SCALE = { S1: 1.35, S5: 1.3, S6: 1.4, S11: 1.35, S13: 1.2, S15: 1.5, S17: 1.55, S9: 1.2, S10: 1.15, S4: 1.1, S18: 1.1 };

  var CSS = '' +
    '.egb-hidden{display:none !important}' +
    '.egb-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(88px,1fr));gap:8px;margin:8px 0 18px}' +
    '.egb-tile{display:flex;flex-direction:column;align-items:center;gap:3px;padding:7px 4px 6px;background:#fff;border:1px solid #d7dadc;border-radius:6px;cursor:pointer;font:inherit;font-size:12px;line-height:1.25;color:inherit;text-align:center;-webkit-appearance:none;appearance:none}' +
    '.egb-tile svg{width:100%;height:48px;display:block}' +
    '.egb-tile:hover{border-color:#8a9297}' +
    '.egb-tile.is-selected{border-color:currentColor;box-shadow:0 0 0 1px currentColor}' +
    '.egb-tile:focus-visible{outline:2px solid currentColor;outline-offset:2px}' +
    '.egb-num{font-weight:700}' +
    '.egb-price{opacity:.72;font-size:11px}' +
    '.egb-font-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:8px;margin:8px 0 18px}' +
    '.egb-font{display:flex;flex-direction:column;align-items:flex-start;gap:2px;padding:8px 10px;background:#fff;border:1px solid #d7dadc;border-radius:6px;cursor:pointer;font:inherit;color:inherit;text-align:left;min-height:58px;-webkit-appearance:none;appearance:none}' +
    '.egb-font:hover{border-color:#8a9297}' +
    '.egb-font.is-selected{border-color:currentColor;box-shadow:0 0 0 1px currentColor}' +
    '.egb-font:focus-visible{outline:2px solid currentColor;outline-offset:2px}' +
    '.egb-font-code{font-size:11px;font-weight:700;opacity:.7;letter-spacing:.04em}' +
    '.egb-font-sample{font-size:19px;line-height:1.15;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis;color:#1c1b1b}' +
    '.egb-font-group{grid-column:1/-1;font-size:12px;font-weight:700;opacity:.75;margin:6px 0 -2px}';

  function injectCss() {
    if (document.getElementById('egb-style')) return;
    var s = document.createElement('style');
    s.id = 'egb-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // ---------- money ----------
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/<[^>]+>/g, '');
  }

  // ---------- product data ----------
  function productJson() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent).product; } catch (e) { return null; }
  }

  function optionValue(position) {
    var checked = document.querySelector('.product-form__single-selector[data-option-position="' + position + '"]:checked');
    if (checked) return checked.value;
    var sel = document.querySelector('select.product-form__single-selector[data-option-position="' + position + '"]');
    return sel ? sel.value : null;
  }

  // ---------- colours ----------
  function plateFor(colorValue) {
    var parts = (colorValue || '').toLowerCase().split('/');
    var plateName = (parts[0] || '').replace(/pattern/g, '').trim();
    var inkName = (parts[1] || '').trim();
    var best = null, bestLen = 0;
    Object.keys(PLATES).forEach(function (k) {
      if (plateName.indexOf(k) > -1 && k.length > bestLen) { best = k; bestLen = k.length; }
    });
    var plate = PLATES[best] || PLATES.gold;
    var ink = null, inkLen = 0;
    Object.keys(INKS).forEach(function (k) {
      if (inkName.indexOf(k) > -1 && k.length > inkLen) { ink = INKS[k]; inkLen = k.length; }
    });
    if (!ink) ink = (best === 'black' || best === 'navy' || best === 'walnut' || best === 'blue' || best === 'blue marble') ? '#ffffff' : '#111111';
    return { plate: plate, ink: ink, key: best || 'gold' };
  }

  // ---------- badge drawing ----------
  var uid = 0;
  function badgeSvg(key, colorValue) {
    var s = SHAPES[key];
    if (!s) return '';
    var w = s[0], h = s[1], d = s[2];
    var pc = plateFor(colorValue);
    var id = 'egb' + (++uid);
    var pad = 1.5;
    var vb = (-pad) + ' ' + (-pad) + ' ' + (w + 2 * pad) + ' ' + (h + 2 * pad);
    var stops = pc.plate.stops.map(function (c, i, a) {
      return '<stop offset="' + (i / (a.length - 1) * 100).toFixed(0) + '%" stop-color="' + c + '"/>';
    }).join('');
    var defs = '<defs><linearGradient id="' + id + 'g" x1="0" y1="0" x2="1" y2="1">' + stops + '</linearGradient>' +
      '<clipPath id="' + id + 'c"><path d="' + d + '"/></clipPath></defs>';
    var texture = '';
    if (pc.plate.grain) {
      // wood grain: a few soft darker streaks
      texture = '<g clip-path="url(#' + id + 'c)" opacity=".28" stroke="' + pc.plate.edge + '" stroke-width=".7" fill="none">' +
        [0.18, 0.36, 0.55, 0.74, 0.9].map(function (f) {
          var y = h * f;
          return '<path d="M-2,' + y.toFixed(1) + ' C' + (w * 0.3).toFixed(1) + ',' + (y - h * 0.05).toFixed(1) + ' ' + (w * 0.6).toFixed(1) + ',' + (y + h * 0.05).toFixed(1) + ' ' + (w + 2) + ',' + (y - h * 0.02).toFixed(1) + '"/>';
        }).join('') + '</g>';
    } else if (pc.plate.marble) {
      texture = '<g clip-path="url(#' + id + 'c)" opacity=".35" stroke="#dfe8ff" stroke-width=".9" fill="none">' +
        '<path d="M-2,' + (h * 0.2).toFixed(1) + ' C' + (w * 0.25).toFixed(1) + ',' + (h * 0.5).toFixed(1) + ' ' + (w * 0.45).toFixed(1) + ',' + (h * 0.05).toFixed(1) + ' ' + (w * 0.7).toFixed(1) + ',' + (h * 0.45).toFixed(1) + ' S' + (w + 2) + ',' + (h * 0.6).toFixed(1) + ' ' + (w + 2) + ',' + (h * 0.75).toFixed(1) + '"/>' +
        '<path d="M-2,' + (h * 0.8).toFixed(1) + ' C' + (w * 0.3).toFixed(1) + ',' + (h * 0.95).toFixed(1) + ' ' + (w * 0.5).toFixed(1) + ',' + (h * 0.6).toFixed(1) + ' ' + (w * 0.9).toFixed(1) + ',' + (h * 0.9).toFixed(1) + '"/></g>';
    }
    return '<svg viewBox="' + vb + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true">' + defs +
      '<path d="' + d + '" fill="url(#' + id + 'g)" stroke="' + pc.plate.edge + '" stroke-width=".6"/>' + texture + '</svg>';
  }

  // ---------- shape picker ----------
  function findShapeSelect() {
    var sels = document.querySelectorAll('.product-form__option[data-selector-type="select"] select.product-form__single-selector');
    for (var i = 0; i < sels.length; i++) {
      var opts = sels[i].options, ok = opts.length > 0;
      for (var j = 0; j < opts.length; j++) {
        var m = opts[j].value.trim().match(/^shape\s*(\d+)$/i);
        if (!m || !SHAPES[m[1]]) { ok = false; break; }
      }
      if (ok) return sels[i];
    }
    return null;
  }

  function shapePrice(product, shapeValue, colorValue, shapePos, colorPos) {
    if (!product || !product.variants) return null;
    var exact = null, min = null;
    product.variants.forEach(function (v) {
      if (v['option' + shapePos] !== shapeValue) return;
      if (min === null || v.price < min) min = v.price;
      if (colorPos && v['option' + colorPos] === colorValue) exact = v.price;
    });
    return exact !== null ? exact : min;
  }

  function buildShapes() {
    var sel = findShapeSelect();
    if (!sel) return;
    var wrapper = sel.closest('.product-form__option');
    if (!wrapper) return;
    var product = productJson();
    var shapePos = parseInt(sel.getAttribute('data-option-position'), 10) || 1;
    var colorPos = null;
    if (product && product.options) {
      product.options.forEach(function (name, i) {
        if (/colou?r/i.test(name)) colorPos = i + 1;
      });
    }
    var colorValue = colorPos ? optionValue(colorPos) : null;

    var grid = wrapper.querySelector('.egb-grid');
    var sig = (colorValue || '') + '|' + sel.options.length;
    if (grid && grid.getAttribute('data-sig') === sig) { markShapes(grid, sel); return; }
    if (grid) grid.remove();

    grid = document.createElement('div');
    grid.className = 'egb-grid';
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', 'Badge shape');
    grid.setAttribute('data-sig', sig);

    Array.prototype.forEach.call(sel.options, function (o) {
      var m = o.value.trim().match(/^shape\s*(\d+)$/i);
      var key = m[1];
      var price = shapePrice(product, o.value, colorValue, shapePos, colorPos);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'egb-tile';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('data-value', o.value);
      btn.title = o.text.trim();
      btn.innerHTML = badgeSvg(key, colorValue) +
        '<span class="egb-num">' + key + '</span>' +
        (price !== null ? '<span class="egb-price">' + money(price) + '</span>' : '');
      btn.addEventListener('click', function () {
        var s = findShapeSelect();
        if (!s) return;
        s.value = o.value;
        s.dispatchEvent(new Event('change', { bubbles: true }));
        markShapes(grid, s);
      });
      grid.appendChild(btn);
    });

    var selectWrapper = sel.closest('.select-wrapper');
    if (selectWrapper) selectWrapper.classList.add('egb-hidden');
    wrapper.appendChild(grid);
    markShapes(grid, sel);
  }

  function markShapes(grid, sel) {
    Array.prototype.forEach.call(grid.children, function (b) {
      var on = b.getAttribute('data-value') === sel.value;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  // ---------- font picker ----------
  function findFontSelect() {
    var sels = document.querySelectorAll('select');
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i];
      if (sel.classList.contains('product-form__single-selector') || sel.name === 'id') continue;
      var hits = 0;
      for (var j = 0; j < sel.options.length; j++) {
        if (/^[SP]\d{1,2}$/i.test(sel.options[j].value.trim())) hits++;
      }
      if (hits >= 10) return sel;
    }
    return null;
  }

  var fontsRequested = false;
  function requestFonts() {
    if (fontsRequested) return;
    fontsRequested = true;
    var families = [];
    Object.keys(FONTS).forEach(function (k) { families.push('family=' + FONTS[k].replace(/ /g, '+')); });
    var text = encodeURIComponent(FONT_SAMPLE);
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?' + families.join('&') + '&text=' + text + '&display=swap';
    document.head.appendChild(link);
  }

  function buildFonts() {
    var sel = findFontSelect();
    if (!sel) return;
    var opt = sel.closest('.product-option') || sel.parentElement;
    var host = opt.parentNode;
    var grid = host.querySelector('.egb-font-grid');
    if (grid && grid.previousElementSibling === opt) { markFonts(grid, sel); return; }
    if (grid) grid.remove();

    requestFonts();

    // Tidy the app's label if it carries the old typo.
    var label = opt.querySelector('label, .product-option-title, .product-option__title');
    if (label && /Chioce/.test(label.textContent)) {
      label.childNodes.forEach(function (n) { if (n.nodeType === 3) n.nodeValue = n.nodeValue.replace('Chioce', 'Choice'); });
    }

    grid = document.createElement('div');
    grid.className = 'egb-font-grid';
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', 'Font');

    var lastGroup = '';
    Array.prototype.forEach.call(sel.options, function (o) {
      var code = o.value.trim().toUpperCase();
      if (!/^[SP]\d{1,2}$/.test(code)) return;
      var group = code.charAt(0) === 'S' ? 'Script fonts' : 'Print fonts';
      if (group !== lastGroup) {
        var g = document.createElement('div');
        g.className = 'egb-font-group';
        g.textContent = group;
        grid.appendChild(g);
        lastGroup = group;
      }
      var family = FONTS[code];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'egb-font';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('data-value', o.value);
      btn.title = code + (family ? ' - ' + family : '');
      var size = 19 * (FONT_SCALE[code] || 1);
      btn.innerHTML = '<span class="egb-font-code">' + code + '</span>' +
        '<span class="egb-font-sample" style="' + (family ? 'font-family:\'' + family + '\', cursive;' : '') + 'font-size:' + size.toFixed(1) + 'px">' + FONT_SAMPLE + '</span>';
      btn.addEventListener('click', function () {
        var s = findFontSelect();
        if (!s) return;
        s.value = o.value;
        s.dispatchEvent(new Event('change', { bubbles: true }));
        markFonts(grid, s);
      });
      grid.appendChild(btn);
    });

    var selWrap = sel.closest('.custom-select-wrapper') || sel;
    selWrap.classList.add('egb-hidden');
    host.insertBefore(grid, opt.nextSibling);
    markFonts(grid, sel);
  }

  function markFonts(grid, sel) {
    Array.prototype.forEach.call(grid.children, function (b) {
      if (!b.classList.contains('egb-font')) return;
      var on = b.getAttribute('data-value') === sel.value;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  // ---------- wiring ----------
  function build() {
    injectCss();
    buildShapes();
    buildFonts();
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; build(); }, 40);
  }

  document.addEventListener('variant:changed', soon);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('product-form__single-selector')) soon();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  window.addEventListener('load', soon);
  // The uploader app draws its dropdowns after load, so keep looking for a little while.
  var tries = 0;
  var timer = setInterval(function () {
    build();
    if (++tries > 40 || (findFontSelect() && document.querySelector('.egb-font-grid'))) clearInterval(timer);
  }, 500);
})();
